import React from 'react';
import './VideoList.css';

const formatCountLabel = (count) => {
	if (!count || Number.isNaN(count)) {
		return 'No timestamps';
	}

	if (count === 1) {
		return '1 timestamp';
	}

	return `${count} timestamps`;
};

const formatGeneratedLabel = (value) => {
	if (!value) {
		return null;
	}

	const date = new Date(value);
	if (Number.isNaN(date.getTime())) {
		return null;
	}

	try {
		return date.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
	} catch (error) {
		console.error('Failed to format generated label:', error);
		return date.toString();
	}
};

const VideoList = ({ items = [], onRefresh, onSelect, onDelete, refreshing = false, layout = 'standalone' }) => {
	const hasItems = Array.isArray(items) && items.length > 0;
	const rootClassName = layout === 'embedded' ? 'video-list-card' : 'video-list-section';

	const handleRefresh = () => {
		if (typeof onRefresh === 'function') {
			onRefresh();
		}
	};

	const handleSelect = (item) => {
		if (typeof onSelect === 'function') {
			onSelect(item);
		}
	};

	const handleDelete = (event, item) => {
		event.stopPropagation();
		event.preventDefault();

		if (typeof onDelete !== 'function') {
			return;
		}

		const confirmed = window.confirm('Remove this saved timestamp run?');
		if (confirmed) {
			onDelete(item);
		}
	};

	return (
		<section className={rootClassName} aria-labelledby="timestamp-history-heading">
			<div className="video-list-header">
				<div className="video-list-header-copy">
					<span className="section-tag subtle">History</span>
					<h3 className="video-list-heading" id="timestamp-history-heading">Recent timestamp runs</h3>
					<p className="video-list-subheading">Saved locally on this device.</p>
				</div>
				<button
					type="button"
					className="video-list-refresh"
					onClick={handleRefresh}
					disabled={refreshing}
				>
					{refreshing ? 'Refreshing…' : 'Refresh'}
				</button>
			</div>
				{hasItems ? (
				<ul className="video-list-grid">
					{items.map((item) => {
						const count = Array.isArray(item.timestampsList) ? item.timestampsList.length : 0;
						const generatedLabel = formatGeneratedLabel(item.generatedAt);
						const key = item.id || `${item.url}-${item.generatedAt || ''}`;

						return (
								<li key={key} className="video-list-item">
								<button
									type="button"
									className="video-list-button"
									onClick={() => handleSelect(item)}
								>
									<div className="video-list-thumbnail" aria-hidden={!item.thumbnail}>
										{item.thumbnail ? (
											<img src={item.thumbnail} alt={item.title ? `Thumbnail for ${item.title}` : 'Video thumbnail'} />
										) : (
											<div className="video-list-thumbnail-fallback">No thumbnail</div>
										)}
									</div>
									<div className="video-list-content">
										<p className="video-list-title">{item.title || 'Untitled video'}</p>
											<div className="video-list-footer">
												<div className="video-list-meta">
													{generatedLabel && (
														<span className="video-list-meta-value">Generated {generatedLabel}</span>
													)}
													{item.model && (
														<span className="video-list-meta-pill">{item.model}</span>
													)}
													<span className="video-list-meta-pill">{formatCountLabel(count)}</span>
												</div>
												{typeof onDelete === 'function' && (
													<button
														type="button"
														className="video-list-delete"
														onClick={(event) => handleDelete(event, item)}
													>
														Remove
													</button>
												)}
										</div>
									</div>
								</button>
							</li>
						);
					})}
				</ul>
			) : (
				<div className="video-list-empty" role="status">
					<p>No saved timestamps yet. Generate timestamps to start building your history.</p>
				</div>
			)}
		</section>
	);
};

export default VideoList;
